"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var custom_styles_1 = require("./custom-styles");
exports.default = react_1.default.forwardRef(function LayoutStack(_a, ref) {
    var children = _a.children, _b = _a.spacing, spacing = _b === void 0 ? 8 : _b, _c = _a.visualizeSpacing, visualizeSpacing = _c === void 0 ? false : _c;
    return (react_1.default.createElement(custom_styles_1.Wrapper, { ref: ref, spacing: spacing, visualizeSpacing: visualizeSpacing }, children || react_1.default.createElement(react_1.default.Fragment, null, "Empty LayoutStack")));
});
